/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Generates the theme object for the component from the theme and provided additional information
 * @param  {Object} theme The actual theme object.
 * @return {Object} The final theme object with the overrides and component variables
 */
const generateComponentTheme = theme => {
  var _colors$ui, _colors$contrasts;
  const colors = theme.colors,
    spacing = theme.spacing;
  const componentVariables = {
    bodyPadding: spacing === null || spacing === void 0 ? void 0 : spacing.paddingCardLarge,
    headingBottomMargin: spacing === null || spacing === void 0 ? void 0 : spacing.sectionElements,
    featureNameBottomMargin: spacing === null || spacing === void 0 ? void 0 : spacing.moduleElements,
    permissionLevelTextBottomMargin: spacing === null || spacing === void 0 ? void 0 : spacing.space8,
    permissionLevelBottomMargin: spacing === null || spacing === void 0 ? void 0 : spacing.space8,
    descriptionBottomMargin: spacing === null || spacing === void 0 ? void 0 : spacing.space8,
    permissionLevelsModalTriggerBottomMargin: spacing === null || spacing === void 0 ? void 0 : spacing.moduleElements,
    modelNameTextBottomMargin: spacing === null || spacing === void 0 ? void 0 : spacing.space4,
    modelNameBottomMargin: spacing === null || spacing === void 0 ? void 0 : spacing.space4,
    dividerMargin: spacing === null || spacing === void 0 ? void 0 : spacing.moduleElements,
    dividerColor: colors === null || colors === void 0 ? void 0 : (_colors$ui = colors.ui) === null || _colors$ui === void 0 ? void 0 : _colors$ui.surfaceDivider,
    levelColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts = colors.contrasts) === null || _colors$contrasts === void 0 ? void 0 : _colors$contrasts.violet5790
  };
  return {
    ...componentVariables
  };
};
export default generateComponentTheme;